export default {
  priv: 'pr_reference',
  overviewTitle: 'Groepen',
  detailTitle: 'Groep',
  deleteTitle: 'deze groep',
  url: '/references/groups',
  apiUrl: '/devicegroups/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'refgroups',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/groups/{id}',
      width: '50%'
    },
    {
      text: 'Rapport Prefix',
      value: 'report_prefix',
      width: '25%'
    }
  ]
};
